import { useMemo, useRef } from 'react';
import { ClockWidget } from '../infobar/widgets/ClockWidget.tsx';
import { BarPlanContext, FULL_PLAN } from '../infobar/BarPlanContext.tsx';
import { InfoBarControls, InfoWidgets, WidgetMeasurer } from '../infobar/InfoBar.tsx';
import { useBarLayout } from '../infobar/useBarLayout.ts';
import { useInfoBarPrefs } from '../infobar/prefsStore.ts';

/** The thin bar across the top: widgets on the left, date and clock, bell and settings on the right. */
export function TopBar() {
  const infobar = useInfoBarPrefs();
  const barRef = useRef<HTMLElement>(null);
  const measurerRef = useRef<HTMLDivElement>(null);
  const hidden = useBarLayout(barRef, measurerRef, { bell: infobar.widgets.bell !== false, date: infobar.showDate, seconds: infobar.showSeconds });
  const plan = useMemo(() => ({ hidden }), [hidden]);
  return (
    <BarPlanContext value={plan}>
      <header ref={barRef} className="topbar" data-mode={infobar.position}>
        <InfoWidgets />
        <div className="topbar-end">
          <ClockWidget variant="bar" />
          <InfoBarControls />
        </div>
        <BarPlanContext value={FULL_PLAN}>
          <WidgetMeasurer measurerRef={measurerRef} />
        </BarPlanContext>
      </header>
    </BarPlanContext>
  );
}
